import { Checkbox } from "@/components/ui/checkbox";
import { US_STATES } from "@/lib/constants";

export function StatesPicker({ value, onChange, testId }) {
  const selected = value || [];
  const toggle = (code) => onChange(selected.includes(code) ? selected.filter((c) => c !== code) : [...selected, code]);
  return (
    <div className="border rounded-md p-3" data-testid={testId}>
      <div className="flex items-center justify-between mb-2">
        <p className="text-xs text-zinc-500">{selected.length ? `${selected.length} state${selected.length > 1 ? "s" : ""} selected` : "No states selected yet"}</p>
        {selected.length > 0 && <button className="text-xs text-cc-blue hover:underline" onClick={() => onChange([])} data-testid={`${testId}-clear`}>Clear all</button>}
      </div>
      <div className="grid grid-cols-4 gap-1.5 max-h-52 overflow-y-auto cc-scroll">
        {US_STATES.map(([code, name]) => (
          <label key={code} title={name} className={`flex items-center gap-1.5 text-xs px-1.5 py-1 rounded cursor-pointer ${selected.includes(code) ? "bg-cc-blue/10 text-cc-blue" : "hover:bg-zinc-50 text-zinc-600"}`}>
            <Checkbox checked={selected.includes(code)} onCheckedChange={() => toggle(code)} data-testid={`${testId}-${code}`} />
            {code}
          </label>
        ))}
      </div>
    </div>
  );
}
